import { ReactElement } from 'react';
import { Stack, Typography, Button, Tooltip } from '@mui/material';

import { OrderActiveFiltersProps } from './types';
import { OrderActiveFiltersChip } from './styles';

const OrderActiveFilters = ({
  filters,
  onClearFilters,
}: OrderActiveFiltersProps): ReactElement => {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="body2" fontWeight="bold" flexShrink={0}>
        Filtros activos
      </Typography>

      <Stack direction="row" gap={1} flexWrap="wrap">
        {filters.map((filter) => (
          <Tooltip
            key={`order-active-filter-${filter.id}`}
            title={filter.tooltip}
            arrow
          >
            <OrderActiveFiltersChip
              size="small"
              label={filter.label}
              onDelete={filter.onClear}
            />
          </Tooltip>
        ))}
      </Stack>

      <Button
        variant="text"
        color="primary"
        size="small"
        onClick={onClearFilters}
        sx={(currentTheme) => ({
          ...currentTheme.typography.caption,
          fontWeight: currentTheme.typography.fontWeightLight,
          flexShrink: 0,
        })}
      >
        Borrar Filtros
      </Button>
    </Stack>
  );
};

export default OrderActiveFilters;
